import { useEffect } from "react";
import { applySeo, setJsonLd, type SeoOptions } from "@/lib/seo";

/** Titre/description/canonical/OG/Twitter pour la page courante. */
export function useSeo(opts: SeoOptions) {
  useEffect(() => {
    applySeo(opts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opts.title, opts.description, opts.path, opts.image, opts.type, opts.noindex]);
}

/**
 * Injecte un bloc JSON-LD propre à la page courante (BreadcrumbList, etc.) et
 * le retire au démontage pour ne pas le laisser fuiter vers la page suivante.
 * `data` peut être `undefined` tant que les données source ne sont pas prêtes.
 */
export function useJsonLd(id: string, data: unknown | undefined) {
  useEffect(() => {
    if (data === undefined) return;
    setJsonLd(id, data);
    return () => setJsonLd(id, null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, JSON.stringify(data)]);
}
